export default __webpack_public_path__ + "static/delivering-da6870b44c7112b275d6c4df96f6f34e.webp";